import { useEffect, useState } from "react";
import axios from "axios";
import { Alert, Card, Typography } from "@mui/material";

export default function PetRemovalHistory({ petId, ownerId }: { petId?: string; ownerId?: string }) {
    const [rows, setRows] = useState<any[]>([]);
    const [error, setError] = useState("");
    useEffect(() => {
        let active = true;
        axios.get(`${process.env.VITE_APP_API_BASE_URL}Admin/pet-removal-audit`, { params: { petId, ownerId } })
            .then(({ data }) => {
                if (!data.succeeded) throw new Error("Unable to load removal history.");
                if (active) { setRows(data.result || []); setError(""); }
            }).catch(() => { if (active) setError("Unable to load removal history."); });
        return () => { active = false; };
    }, [petId, ownerId]);
    return <Card className="p-[28px]">
        <Typography variant="h6">Pet removal history</Typography>
        {error && <Alert severity="error">{error}</Alert>}
        {!rows.length && !error && <Typography>No removal records.</Typography>}
        {rows.map(row => <div key={row.id} className="py-8 border-b">
            <Typography>{row.petName} — {row.reason.replace(/_/g, " ")}</Typography>
            <Typography>Recorded {new Date(/(?:Z|[+-]\d\d:\d\d)$/.test(row.recordedAtUtc) ? row.recordedAtUtc : `${row.recordedAtUtc}Z`).toLocaleString()} · Actor: {row.actorEmail || row.actorUserId}</Typography>
            <Typography>Pet ID: {row.petId}</Typography>
        </div>)}
    </Card>;
}
